import {
  GET_TRANSACTIONS, GET_TRANSACTION_DETAILS,
} from '../actionTypes';

const initialState = {
  transactions: [],
  isLoading: false,
  error: false,
  message: '',
  selectedTransaction: {},
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case `${GET_TRANSACTIONS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case `${GET_TRANSACTIONS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_TRANSACTIONS}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        transactions: payload.data.data || [],
      };

    case `${GET_TRANSACTION_DETAILS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        selectedTransaction: {},
      };
    case `${GET_TRANSACTION_DETAILS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_TRANSACTION_DETAILS}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        selectedTransaction: payload.data.data || [],
      };

    default:
      return state;
  }
}
